import React from 'react';

const DefaultPageTemplate: React.FC<{ children?: React.ReactNode | React.ReactNode[] }> = ({ children }) => {
  return (
    <div>
      {children}
    </div>
  )
}
export default DefaultPageTemplate;